const initialState = {
  location: {
    lat: null,
    long: null,
    pincode: null,
    address: null,
    latitudeFromPincode: null,
    longitudeFromPincode: null,
  },
  user: {
    name: null,
    age: null,
    gender: null,
    relation: null,
    primaryHealthId: null,
    bookingHealthId: null,
  },
  menu: true,
  menuDrawer: false,
  booking: {
    lat: null,
    long: null,
    pincode: null,
    doctor_id: null,
    partner_consult_center_id: null,
    order_id: null,
    slot_id: null,
    address: null,
    date: null,
    time: null,
    vaccination_min_age_limit: null,
    color_age_rule: null,
    center_description: null,
    distance: null,
    centre_image: null,
    phone_number: null,
  },
};

const combineReducers = (reducers) => {
  return (state, action) => {
    return Object.keys(reducers).reduce((acc, prop) => {
      return {
        ...acc,
        ...reducers[prop]({ [prop]: acc[prop] }, action),
      };
    }, state);
  };
};

export { initialState, combineReducers };
